(function($){
    $(document).ready(function(){
        $('.home-logo-slider .slider').slick({
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0, /* Kluczowy element do płynnego ruchu */
            cssEase: 'linear',
            arrows: false,
            pauseOnHover: false,
            // variableWidth: true,
            touchThreshold: 90,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                },
            ]
        });
    })
})(jQuery)